import React from 'react';
import PropTypes from 'prop-types';
import { Icon, grey600 } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    color: grey600,
    marginRight: '0.375rem',
  },
});

function SocialShareCopyLink({ handleOpenCopyModal, linkTitle }) {
  return (
    <Icon
      name="share-link"
      onClick={handleOpenCopyModal}
      className={`${css(styles.iconLink)}`}
      title={linkTitle}
      role="link"
      tabIndex="0"
      data-testid="social-share-copy-link"
      size="lg"
    />
  );
}

SocialShareCopyLink.propTypes = {
  url: PropTypes.string,
  handleOpenCopyModal: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareCopyLink;
